// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"eda2d399","518":"28473246","564":"b72877ee","787":"59121205","827":"6730fc2f"}[chunkId] + ".chunk.js";
};